export const CLEANUP_HIDE_ALL = 'CLEANUP_HIDE_ALL';
export const CLEANUP_OPTIONS = 'CLEANUP_OPTIONS';
export const CLEANUP_CONFIRM = 'CLEANUP_CONFIRM';
export const CLEANUP_PROGRESS = 'CLEANUP_PROGRESS';
export const CLEANUP_SUCCESS = 'CLEANUP_SUCCESS';
export const CLEANUP_ERROR = 'CLEANUP_ERROR';
export const BACKUP_LOCKED = 'BACKUP_LOCKED';
export const CLEANUP_ALREADY_RUNNING = 'CLEANUP_ALREADY_RUNNING';
